import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import IntegrationConnector from '../components/IntegrationConnector'

const ArticleLink = "https://apidocs.helpdocs.io/article/qVqI4u0iqG-managing-api-keys"

class HelpDocs extends Component {
  state = {
    key: ''
  }

  getConnectionPayload = () => {
    const { key } = this.state
    return { key }
  }

  renderInput = () => (
      <div>
        <Input
          placeholder="Enter your HelpDocs API Key"
          label="DOCS API KEY"
          valueLink={{
            requestChange: (input) => {
              this.setState({ key: input })
            },
            value: this.state.key
          }}
          isValid={ !!this.state.key }
        />
        <div className="dsg-Body color-gray-dark">
          Need help finding your Docs API key? Here’s <a target="_blank" href={ArticleLink}> an article from HelpDocs</a>.
        </div>
      </div>
    )

  render() {
    const { isConnected } = this.props
    return (
      <div>
        <p>Use Drift’s intelligent messaging to answer your visitors questions using
          your Help Docs knowledge base.</p>
        <p>Just plugin your Docs API key and connect.</p>
        { isConnected ? null : this.renderInput() }
        <IntegrationConnector
          integrationId="helpdocsio"
          isConnected={isConnected}
          connectionPayload={this.getConnectionPayload()}/>
      </div>
    )
  }
}

export default HelpDocs



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/HelpDocs.js